import { render } from "./OptionTags.vue?vue&type=template&id=74cc8166&ts=true"
import script from "./OptionTags.vue?vue&type=script&lang=ts"
export * from "./OptionTags.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/myittar_pharmacy_pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__